import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'itl-desktop-page-action-item',
  templateUrl: './desktop-page-action-item.component.html',
  styleUrls: ['./desktop-page-action-item.component.scss'],
})
export class DesktopPageActionItemComponent {
  @Output() clicked: EventEmitter<null> = new EventEmitter<null>();
}
